import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AdminAuditRoute } from '@/features/admin/routes/AdminAuditRoute';
import { AdminDashboardRoute } from '@/features/admin/routes/AdminDashboardRoute';
import { AdminGate } from '@/features/admin/routes/AdminGate';
import { AdminInsightsRoute } from '@/features/admin/routes/AdminInsightsRoute';
import { AdminMapRoute } from '@/features/admin/routes/AdminMapRoute';
import { AdminSettingsRoute } from '@/features/admin/routes/AdminSettingsRoute';
import { AdminShell } from '@/features/admin/routes/AdminShell';
import { AdminUsersRoute } from '@/features/admin/routes/AdminUsersRoute';
import { AdminVerificationsRoute } from '@/features/admin/routes/AdminVerificationsRoute';
import { LoginRoute } from '@/features/auth/routes/LoginRoute';
import { AvailabilityRoute } from '@/features/availability/routes/AvailabilityRoute';
import { CalendarRoute } from '@/features/calendar/routes/CalendarRoute';
import { BrowseRequestsRoute } from '@/features/coverage/routes/BrowseRequestsRoute';
import { CreateRequestRoute } from '@/features/coverage/routes/CreateRequestRoute';
import { MyApplicationsRoute } from '@/features/coverage/routes/MyApplicationsRoute';
import { MyRequestsRoute } from '@/features/coverage/routes/MyRequestsRoute';
import { RequestDetailRoute } from '@/features/coverage/routes/RequestDetailRoute';
import { CredentialsRoute } from '@/features/credentials';
import { MasjidsRoute, MasjidMembersRoute } from '@/features/masjid';
import { NotificationsRoute } from '@/features/notifications';
import { EditProfileRoute, OnboardingRoute, ProfileRoute } from '@/features/profile';
import {
  AdminTicketsRoute,
  MyTicketsRoute,
  NewTicketRoute,
  TicketDetailRoute,
} from '@/features/support';

import { AppShell, HomeRedirect } from './AppShell';
import { MoreRoute } from './MoreRoute';
import { RootGate } from './RootGate';

export const router = createBrowserRouter([
  {
    element: <RootGate />,
    children: [
      { path: '/login', element: <LoginRoute /> },
      { path: '/onboarding', element: <OnboardingRoute /> },
      {
        element: <AppShell />,
        children: [
          { index: true, element: <HomeRedirect /> },
          { path: 'browse', element: <BrowseRequestsRoute /> },
          { path: 'availability', element: <AvailabilityRoute /> },
          { path: 'applications', element: <MyApplicationsRoute /> },
          { path: 'masjids', element: <MasjidsRoute /> },
          { path: 'masjids/:id/members', element: <MasjidMembersRoute /> },
          { path: 'requests', element: <MyRequestsRoute /> },
          { path: 'requests/create', element: <CreateRequestRoute /> },
          { path: 'requests/:id', element: <RequestDetailRoute /> },
          { path: 'profile', element: <ProfileRoute /> },
          { path: 'profile/edit', element: <EditProfileRoute /> },
          { path: 'calendar', element: <CalendarRoute /> },
          { path: 'credentials', element: <CredentialsRoute /> },
          { path: 'notifications', element: <NotificationsRoute /> },
          { path: 'more', element: <MoreRoute /> },
          { path: 'support', element: <MyTicketsRoute /> },
          { path: 'support/new', element: <NewTicketRoute /> },
          { path: 'support/tickets/:id', element: <TicketDetailRoute /> },
          {
            element: <AdminGate />,
            children: [
              {
                element: <AdminShell />,
                children: [
                  { path: 'admin', element: <AdminDashboardRoute /> },
                  { path: 'admin/insights', element: <AdminInsightsRoute /> },
                  { path: 'admin/users', element: <AdminUsersRoute /> },
                  { path: 'admin/map', element: <AdminMapRoute /> },
                  { path: 'admin/verifications', element: <AdminVerificationsRoute /> },
                  { path: 'admin/tickets', element: <AdminTicketsRoute /> },
                  { path: 'admin/audit', element: <AdminAuditRoute /> },
                  { path: 'admin/settings', element: <AdminSettingsRoute /> },
                ],
              },
            ],
          },
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
